import App from 'app/app.js';
import 'app/store/ContentStore.js';

function LtSelectionTemplateFieldTranslateFilter(ContentStore) {
  return function (field, templateName, fieldType, param) {
    var fieldDataMap = [];
    var translatedData;

    if (!!templateName) {
      if (fieldType.toUpperCase() === 'DESCRIPTION') {
        //translated text for description. Description field is not part of Field object
        return ContentStore.getSelectionTemplateField(templateName.toUpperCase(), fieldType.toUpperCase());
      }
      //for string, example and integer
      return ContentStore.getSelectionTemplateField(
        templateName.toUpperCase(),
        field.name.toUpperCase().replace(/\s/g, '_') + '_' + fieldType.toUpperCase()
      );
    }
  };
}

App.filter('ltSelectionTemplateFieldTranslateFilter', ['ContentStore', LtSelectionTemplateFieldTranslateFilter]);
